/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SpecVitalResult from './spec-vital-result';
import SpecVitalResultDetail from './spec-vital-result-detail';
import SpecVitalResultUpdate from './spec-vital-result-update';
import SpecVitalResultDeleteDialog from './spec-vital-result-delete-dialog';

const SpecVitalResultRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SpecVitalResult />} />
    <Route path="new" element={<SpecVitalResultUpdate />} />
    <Route path=":id">
      <Route index element={<SpecVitalResultDetail />} />
      <Route path="edit" element={<SpecVitalResultUpdate />} />
      <Route path="delete" element={<SpecVitalResultDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SpecVitalResultRoutes;
